module.exports = __webpack_public_path__ + "images/ExternalPromo/weebly-378865-300_250.gif?af1d9";